import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Details from './details';

export default function DeleteModal({ requirement, shown, onClose, onDelete }) {
  const handleDelete = () => {
    onDelete(requirement);
    onClose();
  };

  return (
    <Modal className="delete-requirements-modal" show={shown} onHide={() => onClose()}>
      <Modal.Header closeButton>
        <Modal.Title> Delete Requirement </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="w-100 ph-0">
          <h4 className="mt-3" >
            This action is permanent. Are you sure you want to delete this requirement?
          </h4>
          <Details requirement={requirement} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="pull-right">
          <button className="btn btn-sm btn-cancel" onClick={() => onClose()}>
            Cancel
          </button>
          <button className="btn btn-sm btn-danger ml-2" onClick={() => handleDelete()}>
            Delete
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

DeleteModal.propTypes = {
  requirement: PropTypes.object,
  shown: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
